import { useContext } from 'react';
import CategoryHeader from '../CategoryHeader';
import Button from '../../../shared/Button';
import Box from '../../../shared/layouts/Box';
import CompareContainer from '../CompareContainer';
import CompareAddressSection from './CompareAddressSection';
import CompareHomeSection from './CompareHomeSection';
import { CompareContext } from '../ComparePage';
import {useTranslation} from "react-i18next";
import useIconLibrary from "../../../../hooks/useIconLibrary";

const CompareResidencePage = () => {
  const {
    showOnlyDiff,
    hasDiff,
    ownAddressData,
    ownHouseData,
    setOwnHouseData,
    otherAddressData,
    otherHouseData,
    homeFields,
    addressFields,
    hasPageCopiedFields,
    handleCopyAllFields,
    customOwnAddressSetter,
  } = useContext(CompareContext);

  const { t } = useTranslation();

  const fields = [...homeFields, ...addressFields];
  const { HouseIcon } = useIconLibrary();

  return (
    <CompareContainer
      section="house"
      title={t("Woning")}
      icon={<HouseIcon height="2rem" width="2rem" />}
    >
      {showOnlyDiff &&
      !hasPageCopiedFields('residence') &&
      !hasDiff(fields, ownAddressData, otherAddressData) && !hasDiff(fields, ownHouseData, otherHouseData) ? (
        <Box fontScale="m" width="50%">{t('Geen afwijkende gegevens gevonden')}</Box>
      ) : (
        <>
          <CompareAddressSection />
          <CompareHomeSection />
          <CategoryHeader>
            <div />
            <Button
              onClick={() => {
                handleCopyAllFields(
                  otherAddressData,
                  ownAddressData,
                  'residence',
                  customOwnAddressSetter
                );
                handleCopyAllFields(
                  otherHouseData,
                  ownHouseData,
                  'residence',
                  setOwnHouseData
                );
              }}
            >
              {t('Alle gegevens overnemen')}
            </Button>
          </CategoryHeader>
        </>
      )}
    </CompareContainer>
  );
};

export default CompareResidencePage;
